import React, { useEffect, useState } from 'react';
import SettingWrapper from '../SettingWrapper/SettingWrapper';
import RingtoneDeviceSelect from '../RingtoneDeviceSelect/RingtoneDeviceSelect';
import { useSelector } from 'react-redux';
import { ringtoneDevicesDataSelector } from '../../store/selectors';
import styles from './SettingList.module.scss';

const SettingsList = () => {
  const { deviceList } = useSelector(ringtoneDevicesDataSelector);
  const [displayedDevices, setDisplayedDevices] = useState([]);

  useEffect(() => {
    const defaultDevice = deviceList.find(
      (device) => device.deviceId === 'default'
    );
    const defaultDeviceGroupId = defaultDevice?.groupId;

    const devices = deviceList.filter(
      (device) =>
        device.deviceId === 'default' ||
        (device.deviceId !== 'default' &&
          device.groupId !== defaultDeviceGroupId)
    );

    setDisplayedDevices(devices);
  }, [deviceList]);

  return (
    <ul className={styles.root}>
      {displayedDevices.length > 1 && (
        <SettingWrapper
          title="Устройство для воспроизведения рингтона"
          columnDirection
        >
          <RingtoneDeviceSelect devices={displayedDevices} />
        </SettingWrapper>
      )}
    </ul>
  );
};

export default SettingsList;
